module.exports = __webpack_public_path__ + "img/exportKhazna.e5676328.svg";